import { LocalStorageKey } from 'shared/constants/localStorage'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type DevDrawerStore = {
  isVisible: boolean
  toggle: () => void
  hide: () => void
}

export const useDevDrawerStore = create<DevDrawerStore>()(
  persist(
    set => ({
      isVisible: true,
      toggle: () => set(state => ({ isVisible: !state.isVisible })),
      hide: () => set({ isVisible: false })
    }),
    {
      name: LocalStorageKey.DEV_DRAWER_VISIBLE,
      partialize: state => ({ isVisible: state.isVisible })
    }
  )
)
